import { render, staticRenderFns } from "./ChartReport.vue?vue&type=template&id=4c664706&scoped=true"
import script from "./ChartReport.vue?vue&type=script&lang=js"
export * from "./ChartReport.vue?vue&type=script&lang=js"
import style0 from "./ChartReport.vue?vue&type=style&index=0&id=4c664706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c664706",
  null
  
)

export default component.exports